// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    isPrimary: z.boolean().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    departmentId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    isPrimary: z.boolean(),
});
export const OrganizationDepartmentUserRelations = Object.freeze({
    table: 'organization_department_user_relations',
    tableSingular: 'organization_department_user_relation',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        departmentId: 'department_id',
        userId: 'user_id',
        isPrimary: 'is_primary',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'departmentId',
        'userId',
        'isPrimary',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
